import { FileWarning, FileText, FolderOpen } from "lucide-react"

const notificationIconMap = {
  "fa-exclamation": FileWarning,
  "fa-folder-open-o": FolderOpen,
  default: FileText,
} as const

type BackendIconKey = keyof typeof notificationIconMap
type IconComponent = (typeof notificationIconMap)[BackendIconKey]

export const notificationsIconParser = (icon: string): IconComponent | null =>
  (icon ? notificationIconMap[icon as BackendIconKey] : null) ?? null

const levelToIconColorMap = {
  info: "tw:text-sky-500",
  danger: "tw:text-red-500",
  default: "tw:text-muted-foreground",
} as const

type LevelKey = keyof typeof levelToIconColorMap

export const notificationsIconColorClass = (level: string): string => {
  return levelToIconColorMap[level as LevelKey] || levelToIconColorMap.default
}

const notificationLevelColorMap = {
  info: "tw:border-t-2 tw:border-sky-400",
  danger: "tw:border-t-2 tw:border-red-500",
  default: "tw:border-t tw:border-gray-200",
} as const

type BackendLevelKey = keyof typeof notificationLevelColorMap
type LevelColor = (typeof notificationLevelColorMap)[BackendLevelKey]

export const notificationsLevelColorParser = (
  level: string,
): LevelColor | null =>
  (level ? notificationLevelColorMap[level as BackendLevelKey] : null) ?? null
